import moment from 'moment';
import 'moment-timezone';

let name_mapping = {
  // TODO: later
  // 'America/Los_Angeles' : 'US/Pacific',
};

function guessTz() {
  let tzGuessed = moment.tz.guess();
  if (tzGuessed) {
    // Mapped name
    let mappedName = name_mapping[tzGuessed];

    // When we have a match in mapping, then use that
    if (mappedName) {
      return mappedName;
    } else {
      return tzGuessed;
    }
  }
}
export { guessTz };
